import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";
import { useMemo } from "react";

type Props = CustomCellEditorProps & {
  dataMapVar: any;
  valueVar: any;
  labelVar: any;
  showSearch: any;
  notFoundContent: any;
  isSorting: boolean;
};

function SelectCellEditor(props: Props) {
  const {
    value,
    context,
    dataMapVar,
    valueVar,
    labelVar,
    showSearch,
    stopEditing,
    notFoundContent,
    isSorting = true,
    onValueChange
  } = props;
  const itemsMap = context[dataMapVar];

  const dropDownOptions = useMemo(() => {
    const options = Object.keys(itemsMap).map((key: any) => {
      return {
        label: itemsMap[key][labelVar],
        value: itemsMap[key][valueVar]
      };
    });
    if (isSorting)
      return options.sort((a: any, b: any) => a.label.localeCompare(b.label));
    return options;
  }, [isSorting, itemsMap, labelVar, valueVar]);

  return (
    <Select
      value={dropDownOptions.length > 0 ? value || undefined : undefined}
      autoFocus
      defaultOpen
      placeholder={showSearch ? "Select / Search" : "Select"}
      allowClear
      showSearch={showSearch}
      optionFilterProp="label"
      options={dropDownOptions}
      virtual={false}
      notFoundContent={notFoundContent}
      style={{ width: "100%" }}
      filterOption={(input, option: any) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      onChange={(event: any) => {
        onValueChange(event);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
    />
  );
}

export function SelectCellEditorV2(props: Props) {
  const {
    context,
    value,
    dataMapVar,
    valueVar,
    labelVar,
    showSearch,
    stopEditing,
    notFoundContent,
    isSorting = true,
    onValueChange
  } = props;
  const itemsMap = context[dataMapVar];

  const dropDownOptions = useMemo(() => {
    const options = Object.keys(itemsMap).map((key: any) => {
      return {
        label: itemsMap[key][labelVar],
        value: itemsMap[key][valueVar]
      };
    });
    if (isSorting)
      return options.sort((a: any, b: any) => a.label.localeCompare(b.label));
    return options;
  }, [isSorting, itemsMap, labelVar, valueVar]);

  return (
    <Select
      value={dropDownOptions.length > 0 ? value || undefined : undefined}
      autoFocus
      defaultOpen
      placeholder={showSearch ? "Select / Search" : "Select"}
      allowClear
      showSearch={showSearch}
      optionFilterProp="label"
      options={dropDownOptions}
      virtual={false}
      notFoundContent={notFoundContent}
      style={{ width: "100%" }}
      filterOption={(input, option: any) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      onChange={(_, option: any) => {
        onValueChange(option);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
      onClear={() => {
        onValueChange({
          label: "",
          value: null
        });
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
    />
  );
}

export default SelectCellEditor;
